import styled from 'styled-components';
import { ImageSectionStyled } from '../ImageSectionStyled';
import { rem } from 'polished';

export const ImageSectionStyledAP = styled(ImageSectionStyled)``;
